module.exports = __webpack_public_path__ + "img/India.93ca59a4.svg";